﻿import { apiPaths } from '@/api/ApiPaths';
import requestClient from '@/api/RequestClient';

//Action
export const CONFIRM_ACCOUNT_CONFIRMATION_SUCCESS = 'CONFIRM_ACCOUNT_CONFIRMATION_SUCCESS';
export const CONFIRM_ACCOUNT_CONFIRMATION_ERROR = 'CONFIRM_ACCOUNT_CONFIRMATION_ERROR';

const initialState = {
    error: false,
    errorText: false,
    token: '',
}
 
export default function reducer(state = initialState, action: any) {
    switch (action.type) {
        case CONFIRM_ACCOUNT_CONFIRMATION_SUCCESS: return { ...state, token: action.payload }
        case CONFIRM_ACCOUNT_CONFIRMATION_ERROR: return { ...state, error: true, errorText: action.payload}
        default: return state;
    }
}

//Action creator

export const confirmAccountConfirmationSuccess = (token: any) => {
    return { type: CONFIRM_ACCOUNT_CONFIRMATION_SUCCESS, payload: token }
}

export const confirmAccountConfirmationError = (errorText: string) => {
    return { type: CONFIRM_ACCOUNT_CONFIRMATION_SUCCESS, payload: errorText }
}


//Thunks
export const handleSubmit = () => {

    let userInfo = {
        
    };

    return (dispatch: any) => {
        requestClient.post(apiPaths.account.confirmAccountConfirmation, userInfo)
            .then(function (response) {
                if (response.success) {
                    //navigate
                    //write token to store/reducer
                }
                else {
                    //modify state to show the error message element
                    //responseObject.Error
                }
            }).catch(function (error) {

            });
    }

}